import { useEffect, useRef } from "react";

// Lyrics with optional LRC-style timestamps: "[01:23] line" or "[1:23.5] line". Untimed songs render as plain text.
const TS = /^\s*\[(\d{1,2}):(\d{2}(?:\.\d{1,3})?)\]\s?(.*)$/;

export function parseLyrics(text = "") {
  const lines = text.split("\n");
  const timed = lines.map((l) => { const m = l.match(TS); return m ? { t: parseInt(m[1], 10) * 60 + parseFloat(m[2]), text: m[3] } : null; });
  const hasTimes = timed.filter(Boolean).length >= 2;
  return hasTimes ? { timed: true, lines: timed.map((x, i) => x || { t: null, text: lines[i] }) } : { timed: false, lines: lines.map((l) => ({ t: null, text: l })) };
}

export const plainLyrics = (text = "") => text.split("\n").map((l) => l.replace(TS, "$3")).join("\n");

export function Lyrics({ text, time = 0, active = false, onSeek, className = "" }) {
  const { timed, lines } = parseLyrics(text);
  const ref = useRef(null);
  const currentIdx = timed && active ? lines.reduce((acc, l, i) => (l.t !== null && l.t <= time + 0.15 ? i : acc), -1) : -1;
  useEffect(() => {
    if (currentIdx < 0 || !ref.current) return;
    ref.current.children[currentIdx]?.scrollIntoView({ block: "center", behavior: "smooth" });
  }, [currentIdx]);
  if (!timed) return <pre className={`whitespace-pre-wrap font-sans ${className}`} data-testid="lyrics-plain">{text}</pre>;
  return (
    <ol ref={ref} className={`space-y-1 ${className}`} data-testid="lyrics-timed" data-current-line={currentIdx}>
      {lines.map((l, i) => (
        <li key={i}>
          <button type="button" disabled={l.t === null} onClick={() => l.t !== null && onSeek?.(l.t)} data-testid={`lyric-line-${i}`} data-active={i === currentIdx}
            className={`text-left w-full transition-all duration-300 ${i === currentIdx ? "text-[#e9c46a] font-display text-2xl md:text-3xl leading-tight [text-shadow:0_0_30px_rgba(233,196,106,0.5)]" : i < currentIdx ? "text-[#f3e9d2]/35" : "text-[#f3e9d2]/70"} ${l.t === null ? "cursor-default" : "hover:text-[#f3e9d2]"}`}>
            {l.text || "\u00a0"}
          </button>
        </li>
      ))}
    </ol>
  );
}
